import {
  atom,
  selector
} from 'recoil';
import * as vodaLend from '../api/vodaLend';

const fetchState = async () => {
  const response = await vodaLend.getBusinessDetails();
  return response.data;
};

export const updateState = async (inputData) => {
  const response = await vodaLend.setBusinessDetails(inputData);
  return response.data;
};

export const refreshTriggerState = atom({
  key: 'refreshTriggerState',
  default: 0
});

export const businessDetailsFetch = selector({
  key: 'businessDetailsFetch',
  get: async ({ get }) => {
    get(refreshTriggerState);
    return await fetchState();
  }
});

const businessDetailsDefault = selector({
  key: 'businessDetailsDefault',
  get: async ({ get }) => {
    get(refreshTriggerState);
    return await fetchState();
  }
});

export const businessDetailsState = atom({
  key: 'businessDetailsState',
  default: businessDetailsDefault
});

export const businessDetailsSubmit = selector({
  key: 'businessDetailsSubmit',
  get: async ({ get }) => await get(businessDetailsState),
  set: ({ get, set }, inputData) => {

    const cur = get(businessDetailsState) || {};

    if (inputData.error) {
      const data = Object.fromEntries(
        Object
          .entries({ ...cur, ...inputData })
          .filter(([k, _]) => k !== 'error' && k !== 'traceId')
      );
      set(businessDetailsState, data);
      return;
    }

    set(businessDetailsState, {
      ...cur,
      ...inputData
    });
    set(refreshTriggerState, (prev) => prev + 1); // Add this line to trigger re-fetch
  }
});
